import {app} from '../../app';
import IScope = angular.IScope;
import {SharedQuestionService} from "../../services/SharedQuestionService";
import {ISessionService} from "../../services/SessionService";
import IComponentController = angular.IComponentController;
import {DragAndDropSharedQuestion} from "../../sharedQuestions/DragAndDropSharedQuestion";
import {IUniqueIdService} from "../../services/UniqueIdService";

export class DragAndDropQuestionPreviewComponent {

    protected sessionService:ISessionService;

    question:IQuestion;
    values:{[s: string]: {label:string}[]} = {};
    containers:IDragAndDropContainer[];

    static $inject = ['SessionService'];

    constructor(sessionService:ISessionService) {
        this.sessionService = sessionService;
    }

    public $onInit = () => {
        this.setup();
    };

    setup() {
        this.containers = this.question.meta.containers;
        for (const container of this.containers) {
            let elements = [];
            for (const element of container.elements) {
                elements.push({label: element});
            }

            this.values[container.title] = elements;
        }

        let answer = this.sessionService.getAnswer(this.question.id);
        if (answer && angular.isArray(answer.values)) {
            for (let valueIndex = 0; valueIndex < answer.values.length; valueIndex++) {
                const value = answer.values[valueIndex].value;
                let elements:{label:string}[] = [];

                for (const element of value) {
                    elements.push({label: element});
                }

                this.values[this.containers[valueIndex].title] = elements;
            }
        }
    }

}

app.component('dragAndDropQuestionPreview', {
    templateUrl: 'templates/components/questionPreviews/dragAndDropQuestionPreview.html',
    controller: DragAndDropQuestionPreviewComponent,
    controllerAs: 'dragAndDropQuestionPreview',
    bindings: {
        question: '<'
    }
});